
$(window).on('scroll', function(){
      if($(window).scrollTop() >= $('#fixed_remove').offset().top){
      // $('.sticky-addtocart').addClass('active');
      $('#sticky-atc-bar').fadeIn();
} else {
     //  $('.sticky-addtocart').removeClass('active'); 
     $('#sticky-atc-bar').fadeOut();
}

if($(window).scrollTop() >= $('.shopify-section-group-footer-group').offset().top - 300 ){
      $('.sticky-addtocart').addClass('active_n');
} else {
      $('.sticky-addtocart').removeClass('active_n');
}
});

 //from product.js
$(document).ready(function() { 
    //alert('0');  
    if ($(window).width() < 767) {
    //alert('1');
        $('#newrel-slider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            cssEase: 'linear',
            prevArrow: $('.rel-section_wrap .prev'),
		        nextArrow: $('.rel-section_wrap .next'),
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
        });
    
        $('.slidermobile-gutter ul').slick({
            dots: true,
            infinite: true,
            speed: 500,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            slide: '.product__media-item:visible',
        });
    }
    $('.product_media-list').on('afterChange', function(event, slick, currentSlide){
        document.querySelector('[id^="GalleryViewer"]').dispatchEvent(new CustomEvent('slideChanged', { detail: {
            currentPage: slick.currentSlide,
            currentElement: slick.$slides[currentSlide]
        }}));
    });

}); 
